export default "__VITE_ASSET__2zugD8M6__"